import { c as _c } from "react/compiler-runtime";
import { B2BOptPropertiesTypes } from "@website/widget/login/components/b2b-otp/b2b-otp.types";
import { AuthB2BVerifyOtpService } from "@website/widget/login/services/auth-b2b-verify-otp";
import { AuthRequestOtpService } from "@website/widget/login/services/auth-request-otp";
import { useState } from "react";
import { getLoginErrorMessage } from "../../utils";
export const useB2BOtp = properties => {
  const $ = _c(22);
  const {
    userData,
    onEndAuth,
    setStep,
    setUserData
  } = properties;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSendAgain, setIsLoadingSendAgain] = useState(false);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [showSendAgain, setShowSendAgain] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setOtp(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onChangeOtp = t0;
  let t1;
  if ($[1] !== onEndAuth || $[2] !== otp || $[3] !== setUserData || $[4] !== userData) {
    t1 = async _event => {
      _event.preventDefault();
      const {
        otpId,
        otpLength,
        contractId
      } = userData;
      if (otp.length === otpLength) {
        setIsLoading(true);
        setError("");
        if (otpId) {
          AuthB2BVerifyOtpService({
            otp,
            otpId,
            companyCode: String(contractId)
          }).then(data => {
            const {
              accessToken,
              hasPassword,
              refreshToken,
              userExists
            } = data;
            if (accessToken) {
              setUserData({
                ...userData,
                accessToken,
                hasPassword,
                refreshToken,
                userExists
              });
              onEndAuth?.(accessToken, refreshToken);
            }
          }).catch(error_0 => {
            setError(error_0?.response?.message || error_0?.response?.data?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
          }).finally(() => setIsLoading(false));
        } else {
          setError("\u06A9\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F");
        }
      }
    };
    $[1] = onEndAuth;
    $[2] = otp;
    $[3] = setUserData;
    $[4] = userData;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onSubmitOtp = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowSendAgain(true);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onTimerEnd = t2;
  let t3;
  if ($[7] !== setUserData || $[8] !== userData) {
    t3 = async () => {
      const {
        phoneNumber
      } = userData;
      setIsLoadingSendAgain(true);
      setError("");
      AuthRequestOtpService({
        phoneNumber
      }).then(data_0 => {
        setUserData({
          ...userData,
          ...data_0
        });
        setShowSendAgain(false);
      }).catch(error_1 => {
        setError(getLoginErrorMessage(error_1));
      }).finally(() => setIsLoadingSendAgain(false));
    };
    $[7] = setUserData;
    $[8] = userData;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onClickSendAgain = t3;
  let t4;
  if ($[10] !== setStep || $[11] !== userData) {
    t4 = () => {
      const {
        forgotPassword
      } = userData;
      if (forgotPassword) {
        setStep("password");
      } else {
        setStep("phone-number");
      }
    };
    $[10] = setStep;
    $[11] = userData;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onBackClick = t4;
  let t5;
  if ($[13] !== error || $[14] !== isLoading || $[15] !== isLoadingSendAgain || $[16] !== onBackClick || $[17] !== onClickSendAgain || $[18] !== onSubmitOtp || $[19] !== otp || $[20] !== showSendAgain) {
    t5 = {
      isLoading,
      otp,
      onChangeOtp,
      onSubmitOtp,
      error,
      onBackClick,
      onTimerEnd,
      showSendAgain,
      onClickSendAgain,
      isLoadingSendAgain
    };
    $[13] = error;
    $[14] = isLoading;
    $[15] = isLoadingSendAgain;
    $[16] = onBackClick;
    $[17] = onClickSendAgain;
    $[18] = onSubmitOtp;
    $[19] = otp;
    $[20] = showSendAgain;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};